var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LayoutPublic",
    [
      _c(
        "h1",
        {
          staticClass: "text-xl font-semibold mb-3",
          staticStyle: { "line-height": "inherit" },
        },
        [
          _vm.watch_is_refused
            ? _c("span", {
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("temporary_watchman.title_refused")
                  ),
                },
              })
            : _c("span", {
                domProps: {
                  textContent: _vm._s(_vm.$t("temporary_watchman.title")),
                },
              }),
        ]
      ),
      _vm._v(" "),
      _vm.watch_is_error
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("temporary_watchman.messages.no_data")) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.watch_is_refused
        ? _c("div", {
            staticClass: "alert alert-info mb-3",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("temporary_watchman.messages.watch_refused", {
                  name: _vm.datis.name,
                })
              ),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.watch_is_loading ? _c("UiSpinner") : _vm._e(),
      _vm._v(" "),
      _vm.temporaryWatchData && !_vm.watch_is_refused
        ? [
            _c(
              "p",
              {
                staticClass: "mb-3",
                staticStyle: { "line-height": "inherit" },
              },
              [_vm._v(_vm._s(_vm.$t("temporary_watchman.description")))]
            ),
            _vm._v(" "),
            _vm.temporaryWatchData && _vm.temporaryWatchData.datis
              ? _c(
                  "UiCard",
                  {
                    staticClass: "d-flex align-items-center mx-auto w-fit mb-3",
                  },
                  [
                    _c("div", { staticClass: "mr-3" }, [
                      _c("i", {
                        staticClass: "fa fa-user-circle text-gray-400 text-5xl",
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm.datis.name
                        ? _c("div", { staticClass: "font-semibold" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.datis.name) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.datis.client && _vm.datis.client.enterprise_name
                        ? _c("div", [
                            _vm._v(_vm._s(_vm.datis.client.enterprise_name)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.datis.phone
                        ? _c("div", [_vm._v(_vm._s(_vm.datis.phone))])
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "mb-3" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.$t("temporary_watchman.info_link_url"),
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("temporary_watchman.info_link_text")) +
                      "\n      "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "mb-3" }),
            _vm._v(" "),
            _c("h2", { staticClass: "font-semibold text-xl mb-3" }, [
              _vm._v(_vm._s(_vm.$t("temporary_watchman.confirm_label"))),
            ]),
            _vm._v(" "),
            _vm.temporaryWatchData &&
            _vm.temporaryWatchData.status === "accepted"
              ? _c("div", {
                  staticClass: "alert alert-success mb-3",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "temporary_watchman.messages.watch_already_accepted",
                        { name: _vm.datis.name }
                      )
                    ),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mb-3",
                class:
                  _vm.cgu_is_error && !_vm.cgu_is_accepted ? "text-danger" : "",
              },
              [
                _c(
                  "b-form-checkbox",
                  {
                    attrs: {
                      id: "checkbox-1",
                      name: "checkbox-1",
                      disabled: _vm.temporaryWatchData.status === "accepted",
                    },
                    model: {
                      value: _vm.cgu_is_accepted,
                      callback: function ($$v) {
                        _vm.cgu_is_accepted = $$v
                      },
                      expression: "cgu_is_accepted",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("temporary_watchman.cgu_read")) +
                        "\n        "
                    ),
                    _c(
                      "a",
                      {
                        staticStyle: {
                          color: "inherit",
                          "text-decoration": "underline",
                        },
                        attrs: {
                          href: _vm.$t("temporary_watchman.cgu_link_url"),
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("temporary_watchman.cgu_link_text")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(".\n      "),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex", staticStyle: { gap: "1rem" } },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "font-semibold",
                    attrs: { variant: "warning" },
                    on: {
                      click: function ($event) {
                        return _vm.sendConfirmation(true)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("temporary_watchman.button_confirm")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "font-semibold",
                    attrs: { variant: "light" },
                    on: {
                      click: function ($event) {
                        return _vm.sendConfirmation(false)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("temporary_watchman.button_refuse")) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }